import React from "react";

const NotificationIconForLogin: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props} // Spread props to allow customization
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.9742 76.4065C39.2012 76.4065 34.5063 71.7086 34.5063 65.9332C34.5063 65.8017 34.5063 65.6711 34.514 65.5395C34.5217 65.2007 34.6746 64.8804 34.927 64.654C35.1793 64.4268 35.5157 64.3129 35.8598 64.3398C41.7398 64.797 48.2162 64.797 54.0963 64.3398C54.4328 64.3131 54.7692 64.427 55.0215 64.654C55.2815 64.8804 55.4268 65.2007 55.442 65.5395C55.4496 65.6711 55.4496 65.8018 55.4496 65.9332C55.4498 71.7086 50.7548 76.4065 44.9742 76.4065Z"
        fill="#E62D38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.9741 67.1831C37.389 67.1831 30.3085 66.5255 25.0248 65.3297C18.449 63.8394 15.1074 61.5891 15.1074 58.6422C15.1074 58.4969 15.138 58.3516 15.1838 58.2141C17.9901 50.5563 18.3495 39.2328 18.3495 30.2239C18.3495 23.1395 21.1251 16.4597 26.1716 11.4163C31.2107 6.37172 37.8937 3.59375 44.9741 3.59375C52.0623 3.59375 58.7452 6.37172 63.7841 11.4159C68.8307 16.4594 71.6063 23.1392 71.6063 30.2236C71.6063 39.2325 71.9657 50.5559 74.7643 58.2137C74.8177 58.3514 74.8407 58.4966 74.8407 58.6419C74.8407 61.5888 71.507 63.8391 64.9234 65.3294C59.6476 66.5255 52.567 67.1831 44.9741 67.1831Z"
        fill="#FDCE2F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.9741 67.1828C37.389 67.1828 30.3085 66.5252 25.0248 65.3294C18.449 63.8391 15.1074 61.5888 15.1074 58.6419C15.1074 58.4966 15.138 58.3513 15.1838 58.2138C17.9901 50.5559 18.3495 39.2325 18.3495 30.2236C18.3495 23.1392 21.1251 16.4594 26.1716 11.4159C26.8032 10.7838 27.4605 10.1872 28.1412 9.62734C31.7127 7.8875 35.6526 6.96875 39.724 6.96875C46.8121 6.96875 53.4951 9.74672 58.534 14.7909C63.5805 19.8344 66.3562 26.5142 66.3562 33.5986C66.3562 42.6075 66.7155 53.9309 69.5141 61.5888C69.5676 61.7264 69.5905 61.8716 69.5905 62.0169C69.5905 62.7931 69.359 63.5209 68.8979 64.1994C67.7404 64.6145 66.4157 64.9916 64.9232 65.3294C59.6476 66.5252 52.567 67.1828 44.9741 67.1828Z"
        fill="#FEE797"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.968 41.4564C13.15 41.4564 5.15967 33.4675 5.15967 23.6473C5.15967 13.8287 13.1501 5.83984 22.968 5.83984C32.7858 5.83984 40.7762 13.8287 40.7762 23.6473C40.7762 33.4675 32.7858 41.4564 22.968 41.4564Z"
        fill="#BF1D2D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.968 41.4564C13.15 41.4564 5.15967 33.4675 5.15967 23.6473C5.15967 17.9223 7.87686 12.8203 12.0883 9.56047C14.5575 8.26297 17.3659 7.52734 20.3429 7.52734C30.1608 7.52734 38.1512 15.5163 38.1512 25.3348C38.1512 31.0609 35.4339 36.1634 31.2222 39.4236C28.7531 40.7208 25.9448 41.4564 22.968 41.4564Z"
        fill="#E62D38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.968 17.0842C22.2799 17.0842 21.7216 16.5253 21.7216 15.8341V15.3127C21.7216 14.6222 22.2797 14.0625 22.968 14.0625C23.6561 14.0625 24.2219 14.6222 24.2219 15.3127V15.8341C24.2219 16.5252 23.6561 17.0842 22.968 17.0842ZM25.3996 33.2325H20.5364C19.8483 33.2325 19.29 32.672 19.29 31.9831C19.29 31.2919 19.8482 30.733 20.5364 30.733H21.7216V21.1673H20.5364C19.8483 21.1673 19.29 20.6061 19.29 19.9172C19.29 19.2267 19.8482 18.6678 20.5364 18.6678H25.3996C26.0954 18.6678 26.6535 19.2267 26.6535 19.9172C26.6535 20.6061 26.0954 21.1673 25.3996 21.1673H24.2221V30.733H25.3996C26.0954 30.733 26.6535 31.2919 26.6535 31.9831C26.6535 32.6719 26.0954 33.2325 25.3996 33.2325Z"
        fill="#ECEFF1"
      />
    </svg>
  );
};

export default NotificationIconForLogin;
